module.exports = __webpack_public_path__ + "media/images/front/icon_instagram-d7bfa7a0a4337d500bc36c8e6194324a.png";